import { classNames, Flex, Tooltip, type TooltipProps } from "@opensea/ui-kit"
import type { ComponentPropsWithoutRef } from "react"

function PreviewTooltipContent({
  className,
  ...rest
}: ComponentPropsWithoutRef<typeof Flex>) {
  return (
    <Flex className={classNames("flex overflow-hidden", className)} {...rest} />
  )
}

export type PreviewTooltipProps = TooltipProps

function PreviewTooltip({ children, className, ...rest }: PreviewTooltipProps) {
  return (
    <Tooltip
      align="center"
      attachToCursor
      className={classNames("p-3", className)}
      disablePointerEvents
      side="bottom"
      {...rest}
    >
      {children}
    </Tooltip>
  )
}

export { PreviewTooltip, PreviewTooltipContent }
